// / — the new-chat URL. A pure MATCHER now: the chat surface itself is rendered
// ONCE by the shared parent (routes/chat-shell.tsx), so that '/' and
// '/chat/$sessionId' hold the SAME GenUIChat instance across the mid-turn URL
// swap the chat performs when it mints a session. Rendering GenUIChat here as
// well would put a second instance under a route that unmounts on that swap —
// exactly the bug the shell exists to fix (see chat-shell.tsx's header).
// Registered into the route tree from routes/core.tsx.
import { createRoute } from '@tanstack/react-router';
import { chatShellRoute } from './chat-shell';

export const indexRoute = createRoute({
  getParentRoute: () => chatShellRoute,
  path: '/',
  component: () => null,
});
